import { ClipboardModule } from '@angular/cdk/clipboard';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { MatMenuModule } from '@angular/material/menu';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { CollectionTableModule } from '@component/collection-table';
import { ConfirmationModalModule } from '@component/confirmation-modal';
import { TaskButtonModule } from '@component/task-button';

import { TeamComponent } from './team.component';

@NgModule({
  declarations: [TeamComponent],
  exports: [TeamComponent],
  imports: [
    CollectionTableModule,
    CommonModule,
    ConfirmationModalModule,
    ClipboardModule,
    FormsModule,
    InlineSVGModule,
    MatMenuModule,
    MatTooltipModule,
    MatTableModule,
    MatSortModule,
    RouterModule,
    TaskButtonModule
  ]
})
export class TeamModule {}
